// extracted by mini-css-extract-plugin
export default {"melodyVideo":"PP-z","isFullWidth":"QP-z","landingPageVideo":"RP-z","play":"SP-z","iframeVideo":"TP-z","playHidden":"UP-z","fullwidth":"VP-z"};